<div class="dialog">
    <div class="dialog_header">
        <button mat-icon-button class="close" [disabled]="loading"  (click)="openConfirmDialog()" ><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
                <path id="ic_close"
                    d="M213.746-744.393l-6.441,6.436a1.459,1.459,0,0,1-1.063.457,1.406,1.406,0,0,1-1.046-.457,1.418,1.418,0,0,1-.45-1.054,1.449,1.449,0,0,1,.45-1.037l6.441-6.452-6.441-6.452a1.419,1.419,0,0,1-.441-1.037,1.473,1.473,0,0,1,.441-1.053,1.406,1.406,0,0,1,1.046-.457,1.485,1.485,0,0,1,1.063.441l6.441,6.452,6.458-6.452a1.431,1.431,0,0,1,1.046-.441,1.458,1.458,0,0,1,1.063.457,1.443,1.443,0,0,1,.433,1.053,1.448,1.448,0,0,1-.45,1.037l-6.441,6.452,6.441,6.452a1.419,1.419,0,0,1,.441,1.037,1.473,1.473,0,0,1-.441,1.054,1.406,1.406,0,0,1-1.046.457,1.406,1.406,0,0,1-1.046-.457Z"
                    transform="translate(-204.746 755.5)" fill="#999" />
            </svg>
        </button>
        {{"withdrawalRequests.confirm the Approval of withdrawal request"|translate}}
    </div>
    <div class="dialog_content" mat-dialog-content>
        <p>{{"companyRequests.you can write the reference number and attach the transferring the subscription amount document"|translate}}</p>
        <form [formGroup]="formGroup" id="ApproveRegisterationRequest" (ngSubmit)="OnSubmit()">
            <mat-form-field class="mb-3">
                <mat-label>{{"companyRequests.Reference Number"|translate}}</mat-label>
                <input matInput formControlName="transaction_number" maxlength="50">
                <mat-hint class="pt-1">{{"general.optional"|translate}}</mat-hint>
            </mat-form-field>

            <app-file-manager [allowedExt]="['pdf','jpg', 'png', 'jpeg']" mode="box" [maxFileSize]="2" [maxFiles]="1"
                [label]="'companyRequests.Reference Number'|translate"
                (selectedFiles)="OnSelectFile($event)"></app-file-manager>

        </form>
    </div>
    <div class="dialog_actions" mat-dialog-actions>
        <button mat-button (click)="openConfirmDialog()" type="button" [disabled]="loading" class="btn-secondary">{{"general.Cancel"|translate}}</button>
        <button mat-button class="btn-primary"[ngClass]="{'loading': loading}" [disabled]="loading"
         type="submit" form="ApproveRegisterationRequest"> 
         {{"companyRequests.Confirm Approval"|translate}}</button>

    </div>
</div>